import React, { useState, useEffect } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { useDispatch } from "react-redux";
import { useLazyFetchPersonAllInOrgQuery } from "../../utils/customer/customerTable";
import OwnerDropDown from "../GlobalFeature/Fields/OwnerDropDown";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { pushAlert } from "../../utils/alertSlice";
import BasicSelect from "../Task/BasicSelect";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import Button from "../UniversalComponents/DefaultButton";
import { ADD_UPDATE_DELEGATION, GET_DELEGATION_DATA_EDITE } from "../../utils/constants";
import { getCommonDataBasedOnId, saveData } from "../store/customer/CustomerSocialAddUpdateFunction";
import { fetchManagePermission } from "../../utils/api/managePermissionApi";
import { getCompanyId } from "../../utils/utilityFunctions/localServices";

const AddUpdateCompanyDelegation = ({ isOpen, onClose, handleSubmitData, editData }) => {
  const token = useRequireAuth();
  const dispatch = useDispatch();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  const [message, setMessage] = useState(null);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: editData?.email,
    ownerType: editData?.owner,
    role: editData?.group_id,
  });
  const [groupData, setGroupData] = useState([]);

  const fetchGroupData = async () => {
    try {
      const response = await fetchManagePermission({
        query: {
          company_id: getCompanyId(),
          key: "all_groups",
        },
      });

      if (response?.success) {
        setGroupData(
          response?.data?.map((data) => {
            return {
              label: data?.group_name,
              value: data?.id,
            };
          })
        );
      } else {
        dispatch(
          pushAlert({
            message: response?.message,
            type: "danger",
            visible: true,
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          message: "Something went wrong",
          type: "danger",
          visible: true,
        })
      );
    }
  };

  const [show, setShow] = useState("");

  const initialFormData = {
    owner: 0,
    email: "",
  };

  const fetchTaskEditData = async (editData) => {
    const url = `${GET_DELEGATION_DATA_EDITE}${editData}`;
    const getData = await getCommonDataBasedOnId(url, token?.token);

    if (getData?.data && getData?.data?.length > 0) {
      setFormData(getData?.data[0] || initialFormData);
    }
  };

  useEffect(() => {
    if (editData) fetchTaskEditData(editData);
  }, [editData]);

  const handlePersonData = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      email: value?.email,
      userId: value?.id,
    }));
  };

  const optionListowner = [
    {
      label: "Contributor",
      value: "0",
    },
    {
      label: "Admin",
      value: "1",
    },
  ];

  const handleFieldChange = (e) => {
    const { name, value } = e.target;

    const selectedOption = optionListowner.find((option) => option?.value == value);

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: selectedOption ? selectedOption?.label : value,
    }));
  };

  const handleBasicFieldChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const validate = () => {
    let tempErrors = {};

    if (!formData?.email) {
      tempErrors.email = "Please Select Email from List";
    }
    if (!formData?.ownerType) {
      tempErrors.ownerType = "access is required";
    }
    if (!formData?.role && formData?.ownerType === "Contributor") {
      tempErrors.role = "role is required";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSave = async (event) => {
    event.preventDefault();
    if (!validate()) {
      return false;
    }

    const ownerId = optionListowner?.filter(
      (item) => item?.label?.toLowerCase() === formData?.ownerType?.toLowerCase()
    )[0].value;
    const groupId = groupData?.filter((item) => item?.value === formData?.role)[0]?.value;

    const socialData = {
      company_id: parsedCompanyData.company_id,
      owner: ownerId,
      email: formData?.email,
      user_id: formData?.userId,
      group_id: groupId,
    };

    try {
      const response = await saveData(ADD_UPDATE_DELEGATION, [socialData], token?.token);
      if (response?.message === "Operation successful") {
        onClose();
        handleSubmitData();
        setMessage(response?.message);
        dispatch(pushAlert({ message: response?.message, type: "success", visible: true }));
      } else {
        dispatch(pushAlert({ message: response?.message, type: "danger", visible: true }));
        setShow(response?.message);
        setMessage(response?.message);
      }
    } catch (error) {
      dispatch(
        pushAlert({
          message: error?.response?.data?.message || "An error occurred while submitting the form.",
          type: "danger",
          visible: true,
        })
      );
      console.error("Error saving data:", error);
      dispatch(pushAlert({ message: error?.message, type: "danger", visible: true }));
    }
  };

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonAllInOrgQuery();

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token?.token, data: data, companyId: parsedCompanyData?.company_id });
  };
  const tableDetail = {
    tableidclass: "taskmodelowner",
  };

  const handleInsert = () => {};

  setTimeout(() => {
    setMessage(null);
  }, 5000);
  setTimeout(() => {
    setShow("");
  }, 4000);

  useEffect(() => {
    fetchGroupData();
  }, []);

  return (
    <CustomDrawer open={isOpen} onClose={onClose} editData>
      <div className="z-[999] h-full  bg-white border font-popins overflow-hidden flex flex-col">
        <div className=" flex items-center justify-between py-3 px-6 border-b border-BECBD3">
          <h3 className="text-lg font-500 text-434852 ">{editData ? "Update " : "Add "}Manage Access</h3>

          <button
            onClick={onClose}
            type="button"
            className="text-454545  hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            data-modal-hide="assets-modal"
          >
            <CloseModalImg className="w-3 h-3" />
            <span className="sr-only">Close modal</span>
          </button>
        </div>

        <form onSubmit={handleSave} className="flex flex-col flex-grow overflow-auto  pt-2">
          <div className="px-6">
            <div className="">
              <label htmlFor="chart_of_accounts_id" className="block pb-1 text-base text-434852 pt-2">
                Email <span className=" text-red-500 "> *</span>
                {errors && <span className="text-red-700 text-sm"> {errors?.email}</span>}
              </label>

              <OwnerDropDown
                tableidclass={tableDetail.tableidclass}
                fetchPersonInTable={fetchPersonData}
                DropData={personTableData?.data}
                handleInsert={handleInsert}
                handlePersonData={handlePersonData}
                owner={formData?.email}
              />
            </div>

            <div className="pt-3">
              <label htmlFor="Designation" className="block pb-1 text-base text-434852">
                Access <span className=" text-red-500 "> *</span>
                {errors && <span className="text-red-700 text-sm"> {errors?.ownerType}</span>}
              </label>
              <BasicSelect
                options={optionListowner || []}
                place
                name="ownerType"
                selectedOptions={optionListowner?.filter(
                  (option) => option?.label?.toLowerCase() === formData["ownerType"]?.toLowerCase()
                )}
                onChange={handleFieldChange}
                onClick={() => {}}
                type={"select"}
                size={"medium"}
                label="owner"
              />
            </div>

            {formData?.ownerType?.toLowerCase() === "contributor" && (
              <div className="pt-3">
                <label htmlFor="Designation" className="block pb-1 text-base text-434852">
                  Assgin Group <span className=" text-red-500"> *</span>
                  {errors && <span className="text-red-700"> {errors?.role}</span>}
                </label>
                <BasicSelect
                  options={groupData || []}
                  place
                  name="role"
                  selectedOptions={groupData?.filter((option) => option.value === formData["role"])}
                  onChange={handleBasicFieldChange}
                  onClick={() => {}}
                  type={"select"}
                  size={"medium"}
                  label="Role"
                  showSearch
                />
              </div>
            )}
          </div>
          <div className="sticky bottom-0 bg-white py-4 pr-3 flex justify-end text-md w-full border-t border-DFE2E5 mt-auto">
            {message && <p className="text-green-500 text-right	">{message}</p>}
            <div className="px-2 gap-3 flex">
              <Button variant={"secondary"} onClick={onClose}>
                CANCEL
              </Button>
              {editData ? (
                <Button variant={"primary"} type={"submit"}>
                  UPDATE
                </Button>
              ) : (
                <Button variant={"primary"} type={"submit"}>
                  SAVE
                </Button>
              )}
            </div>
          </div>
        </form>
      </div>
    </CustomDrawer>
  );
};

export default AddUpdateCompanyDelegation;
